import TrashDeleteBtn from "../../../../components/TrashDeleteBtn";
import { dateFormatter, numberFormatter } from "../../../gridFormatters";
import { numberParser } from "../../../Helpers";

export const deviceCapacityPlanDefs = [
    {
        "field": "collection_date",
        "headerName": "Date",
        "sort": "asc",
        "sortingOrder": ['desc','asc'],
        "comparator": (a, b) => {
            const dateA = new Date(a).getTime();
            const dateB = new Date(b).getTime();

            if(dateA === dateB) {
                return 0;
            } else if (dateA > dateB) {
                return 1;
            } else {
                return -1;
            }
        },
        "cellRenderer": dateFormatter
    },
    {
        "field": "used_gb",
        "type": "numericColumn",
        "headerName": "Used",
        "filter": "agNumberColumnFilter",
        "cellRenderer": numberFormatter
    },
    {
        "field": "capacity_gb",
        "type": "numericColumn",
        "headerName": "Effective Capacity",
        "filter": "agNumberColumnFilter",
        "cellRenderer": numberFormatter
    },
    {
        "field": "subscription_capacity_gb",
        "type": "numericColumn",
        "headerName": "80% Threshold",
        "filter": "agNumberColumnFilter",
        "cellRenderer": numberFormatter
    },
    {
        "field": "order_capacity_gb",
        "type": "numericColumn",
        "headerName": "70% Threshold",
        "filter": "agNumberColumnFilter",
        "cellRenderer": numberFormatter
    }
];

export const userInputDefs = [
    {
        "field": "month",
        "headerName": "Date"
    },
      {
        "field": "chartType",
        "headerName": "Metric",
        "cellRenderer": function ({ value }) {
            return `${value?.startsWith('p') ? 'IOPS' : 'GiB'}`
        }
    },
    {
        "field": "capacity",
        "type": "numericColumn",
        "headerName": "Capacity",
        "cellRenderer": numberFormatter,
        "editable": true,
        "cellEditor": "agNumberCellEditor",
        "valueParser": numberParser
    },
    {
        "field": "workload",
        "type": "numericColumn",
        "headerName": "Workload",
        "cellRenderer": numberFormatter,
        "editable": true,
        "cellEditor": "agNumberCellEditor",
        "valueParser": numberParser
    },
    {
        "field": "growth",
        "type": "numericColumn",
        "headerName": "Growth",
        "cellRenderer": function ({ value, data }) {
            if (!value) return '';
            return `${numberFormatter({value})} ${data.growthType === "growth" ? '%' : 'GiB/Mo'}`
        },
        "editable": true,
        "cellEditor": "agNumberCellEditor",
        "valueParser": numberParser
    },
    {
        "field": "notes",
        "headerName": "Notes",
        "editable": true,
        "cellEditor": "agTextCellEditor"
    },
    {
      "headerName": 'Delete',
      "cellRenderer": TrashDeleteBtn
    }
];

export const poolCapacityPlanDefs = [
    {
        "field": "collection_date",
        "headerName": "Month",
        "sort": "asc",
        "sortingOrder": ['desc','asc'],
        "cellRenderer": dateFormatter
    },
    {
        "field": "pool_used",
        "type": "numericColumn",
        "headerName": "Used",
        "filter": "agNumberColumnFilter",
        "cellRenderer": numberFormatter
    },
    {
        "field": "capacity",
        "type": "numericColumn",
        "headerName": "Effective Capacity",
        "filter": "agNumberColumnFilter",
        "cellRenderer": numberFormatter
    },
    {
        "field": "subscription_capacity",
        "type": "numericColumn",
        "headerName": "80% Threshold",
        "filter": "agNumberColumnFilter",
        "cellRenderer": numberFormatter
    },
    {
        "field": "order_capacity",
        "type": "numericColumn",
        "headerName": "70% Threshold",
        "filter": "agNumberColumnFilter",
        "cellRenderer": numberFormatter
    }
];
